import React from 'react'
import PropTypes from 'prop-types'
import { area as d3Area } from 'd3'
import { useD3Selection } from 'hooks'
import isNil from 'lodash/isNil'

function Area({ data, y0, y1, curveFactory, ...props }) {
  const [ref, useSelectionEffect] = useD3Selection()

  // initialize selection with new data
  useSelectionEffect(
    selection => {
      selection.attr(
        'd',
        d3Area()
          .defined(({ x, y }) => !isNil(x) && !isNil(y))
          .curve(curveFactory)
          .x(d => d.x)
          .y0(y0 === undefined ? d => d.y : y0)
          .y1(y1 === undefined ? d => d.y : y1)(data)
      )
    },
    [data]
  )

  return <path ref={ref} {...props} />
}

Area.propTypes = {
  data: PropTypes.array,
  y0: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  y1: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  curveFactory: PropTypes.func,
}

export default React.memo(Area)
